<script setup lang="ts">
import type { AddressFormFieldData } from '@lib/shared';

import { type PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// EVENTS
const emit = defineEmits<{
    selectAddress: [number | undefined, string | undefined];
}>();

// MODEL
const isModalOpen = defineModel<boolean>('open', { required: true });

// COMPOSABLES
const { isMobile } = useResponsive();
const { tt } = useTypedI18n();

// DATA
const price = ref<number>();
const destinationAddress = ref<AddressFormFieldData>();

// METHODS
const onComputePrice = (_price?: number): void => {
    price.value = _price;
};

const onConfirm = (): void => {
    emit('selectAddress', price.value, destinationAddress.value?.fullAddress);
    isModalOpen.value = false;
};
</script>

<template>
    <UModal v-model:open="isModalOpen" :fullscreen="isMobile" :title="tt('sdp.vas.logisticsModal.title')" v-bind="modalNoDescAriaFixupProps">
        <template #body>
            <div class="space-y-4">
                <p class="text-muted">{{ tt('sdp.vas.logisticsModal.description') }}</p>
                <VasComputePriceLogistics
                    v-model="destinationAddress"
                    :sale="sale"
                    name="logisticsDestinationAddress"
                    @compute-price="onComputePrice"
                />
                <UButton size="xl" :label="tt('sdp.vas.logisticsModal.confirm')" block :disabled="!destinationAddress" @click="onConfirm" />
            </div>
        </template>
    </UModal>
</template>
